var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.metaVerified || _vm.isDev || _vm.isQa
    ? _c(
        "div",
        [
          _vm.data && !_vm.isSecondaryCaregiver
            ? _c(
                "div",
                [
                  _c("Top"),
                  _vm._v(" "),
                  _c("div", { staticClass: "container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-md-6" },
                        [
                          _c("Pagination", {
                            attrs: { numberOfDots: 4, numberOfVisitedDots: 1 }
                          }),
                          _vm._v(" "),
                          _c("img", {
                            staticClass: "img-fluid margin-right-2",
                            attrs: {
                              src: require("@/assets/img/heart.svg?data"),
                              alt: "Ett FH hjärta"
                            }
                          }),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix" }),
                          _vm._v(" "),
                          _vm.fullname && _vm.fullname.length > 0
                            ? _c("div", { staticClass: "header-wrapper" }, [
                                _c(
                                  "h3",
                                  {
                                    staticClass: "text-primary-fh left-header"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.data.welcomepage.greetingsHeader +
                                          _vm.toTitleCase(_vm.fullname)
                                      ) + "!"
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          !_vm.isIndexPatient && !_vm.isCardioPatient
                            ? _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.welcomepage.greetingsText
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isIndexPatient
                            ? _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.welcomepage.greetingsTextIdx
                                  )
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isCardioPatient
                            ? _c("p", {
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.data.welcomepage.greetingsTextCardio
                                  )
                                }
                              })
                            : _vm._e()
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6" }, [
                        !_vm.isIndexPatient
                          ? _c("h4", {
                              staticClass: "left-header",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.welcomepage.personaldataHeader
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isIndexPatient
                          ? _c("h4", {
                              staticClass: "left-header",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.welcomepage.personaldataHeaderIdx
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "clearfix" }),
                        _vm._v(" "),
                        !_vm.isIndexPatient
                          ? _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.welcomepage.personaldataText
                                )
                              }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isIndexPatient
                          ? _c("p", {
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.data.welcomepage.personaldataTextIdx
                                )
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm" })
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "clearfix" }),
                    _vm._v(" "),
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-sm" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-md-6" }, [
                        _vm.age
                          ? _c("div", [
                              _c("div", { staticClass: "card" }, [
                                _c("h4", {
                                  staticClass: "text-primary-fh left-header",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.data.welcomepage.consentScreeningText
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "btn-group btn-group-toggle justify-content-center"
                                  },
                                  [
                                    _c(
                                      "label",
                                      {
                                        staticClass:
                                          "btn btn-outline-secondary btn-lg radio-btn",
                                        class:
                                          _vm.consent === true ? "active" : ""
                                      },
                                      [
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.consent,
                                              expression: "consent"
                                            }
                                          ],
                                          staticClass: "form-check-input",
                                          attrs: { type: "checkbox" },
                                          domProps: {
                                            checked: Array.isArray(_vm.consent)
                                              ? _vm._i(_vm.consent, null) > -1
                                              : _vm.consent
                                          },
                                          on: {
                                            change: function($event) {
                                              var $$a = _vm.consent,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    (_vm.consent = $$a.concat([
                                                      $$v
                                                    ]))
                                                } else {
                                                  $$i > -1 &&
                                                    (_vm.consent = $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      ))
                                                }
                                              } else {
                                                _vm.consent = $$c
                                              }
                                            }
                                          }
                                        }),
                                        _vm._v(" Ja\n                ")
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("br")
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }),
                              _vm._v(" "),
                              _vm.age >= 18
                                ? _c("div", { staticClass: "card" }, [
                                    _c("p", {
                                      staticClass:
                                        "text-primary-fh left-header",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.data.welcomepage
                                            .consentResearch18Plus
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "btn-group btn-group-toggle",
                                        class: !_vm.consent
                                          ? "btn-group-disabled"
                                          : ""
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "btn btn-outline-secondary btn-lg btn-block radio-btn",
                                            class:
                                              _vm.research === true
                                                ? "active"
                                                : ""
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.research,
                                                  expression: "research"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                autocomplete: "off"
                                              },
                                              domProps: {
                                                value: true,
                                                checked: _vm._q(
                                                  _vm.research,
                                                  true
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.research = true
                                                }
                                              }
                                            }),
                                            _vm._v("Ja\n                ")
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "clearfix" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "btn btn-outline-secondary btn-lg btn-block radio-btn",
                                            class:
                                              _vm.research === false
                                                ? "active"
                                                : ""
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.research,
                                                  expression: "research"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                autocomplete: "off"
                                              },
                                              domProps: {
                                                value: false,
                                                checked: _vm._q(
                                                  _vm.research,
                                                  false
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.research = false
                                                }
                                              }
                                            }),
                                            _vm._v("Nej\n                ")
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.age >= 15 && _vm.age <= 17
                                ? _c("div", { staticClass: "card" }, [
                                    _c("p", {
                                      staticClass:
                                        "text-primary-fh left-header",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.data.welcomepage
                                            .consentResearch15to17
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "btn-group btn-group-toggle",
                                        class: !_vm.consent
                                          ? "btn-group-disabled"
                                          : ""
                                      },
                                      [
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "btn btn-outline-secondary btn-lg btn-block radio-btn",
                                            class:
                                              _vm.research === true
                                                ? "active"
                                                : ""
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.research,
                                                  expression: "research"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                autocomplete: "off"
                                              },
                                              domProps: {
                                                value: true,
                                                checked: _vm._q(
                                                  _vm.research,
                                                  true
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.research = true
                                                }
                                              }
                                            }),
                                            _vm._v("Ja\n                ")
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "clearfix" }),
                                        _vm._v(" "),
                                        _c(
                                          "label",
                                          {
                                            staticClass:
                                              "btn btn-outline-secondary btn-lg btn-block radio-btn",
                                            class:
                                              _vm.research === false
                                                ? "active"
                                                : ""
                                          },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.research,
                                                  expression: "research"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                autocomplete: "off"
                                              },
                                              domProps: {
                                                value: false,
                                                checked: _vm._q(
                                                  _vm.research,
                                                  false
                                                )
                                              },
                                              on: {
                                                change: function($event) {
                                                  _vm.research = false
                                                }
                                              }
                                            }),
                                            _vm._v("Nej\n                ")
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.age > 12 && _vm.age < 15
                                ? _c("div", { staticClass: "card" }, [
                                    _c("p", {
                                      staticClass: "text-primary-fh",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.data.welcomepage
                                            .consentDisclaimerTextMinor
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.careGiver.phonenumber,
                                          expression: "careGiver.phonenumber"
                                        }
                                      ],
                                      staticClass:
                                        "form-control form-control-lg form-control-block phone-number-input",
                                      attrs: {
                                        id: "phone-number-input",
                                        type: "text",
                                        placeholder: "Telefonnummer",
                                        maxlength: 10
                                      },
                                      domProps: {
                                        value: _vm.careGiver.phonenumber
                                      },
                                      on: {
                                        input: [
                                          function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.careGiver,
                                              "phonenumber",
                                              $event.target.value
                                            )
                                          },
                                          function($event) {
                                            return _vm.enforceNumbers()
                                          }
                                        ]
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "clearfix--min" }),
                                    _vm._v(" "),
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.careGiver.email,
                                          expression: "careGiver.email"
                                        }
                                      ],
                                      staticClass:
                                        "form-control form-control-lg",
                                      class:
                                        _vm.careGiver.email &&
                                        _vm.careGiver.email.length > 0 &&
                                        !_vm.validEmail(_vm.careGiver.email)
                                          ? "invalid"
                                          : "",
                                      attrs: {
                                        type: "text",
                                        placeholder: "E-post"
                                      },
                                      domProps: { value: _vm.careGiver.email },
                                      on: {
                                        input: [
                                          function($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.careGiver,
                                              "email",
                                              $event.target.value
                                            )
                                          },
                                          function($event) {
                                            _vm.research = null
                                          }
                                        ]
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "clearfix--min" }),
                                    _vm._v(" "),
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-primary btn-lg btn-block",
                                        attrs: {
                                          disabled:
                                            !_vm.checkIfDirty() ||
                                            _vm.minorHasSentNotification
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.sendNotificationToCareGiver()
                                          }
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n              Skicka notis till vårdnadshavare\n              "
                                        )
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm._m(0),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }),
                              _vm._v(" "),
                              _c(
                                "button",
                                {
                                  staticClass:
                                    "btn btn-primary btn-lg btn-block",
                                  attrs: {
                                    disabled:
                                      !_vm.consent ||
                                      (!_vm.minorHasSentNotification &&
                                        _vm.research === null)
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.giveConsents()
                                    }
                                  }
                                },
                                [_vm._v("\n            Nästa\n            ")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "clearfix" }),
                              _vm._v(" "),
                              !_vm.isIndexPatient
                                ? _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.data.welcomepage
                                          .consentDisclaimerText
                                      )
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.isIndexPatient
                                ? _c("p", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.data.welcomepage
                                          .consentDisclaimerTextIdx
                                      )
                                    }
                                  })
                                : _vm._e()
                            ])
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-sm" })
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "clearfix" }),
                  _vm._v(" "),
                  _c("Bottom")
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isSecondaryCaregiver && _vm.data
            ? _c(
                "div",
                {
                  staticClass: "modal fade wrapper-margin-top",
                  attrs: {
                    id: "secondaryCaregiverModal",
                    role: "dialog",
                    "aria-labelledby": "secondaryCaregiverModalLabel",
                    "aria-hidden": "true"
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "modal-dialog",
                      attrs: { role: "document" }
                    },
                    [
                      _c("div", { staticClass: "modal-content" }, [
                        _c("div", { staticClass: "modal-header" }, [
                          _c(
                            "h5",
                            {
                              staticClass: "modal-title",
                              attrs: { id: "secondaryCaregiverModalLabel" }
                            },
                            [
                              _vm._v(
                                "Som vårdnadshavare - ditt samtycke behövs"
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "close",
                              attrs: { type: "button", title: "Logga ut" },
                              on: {
                                click: function($event) {
                                  return _vm.closeModal()
                                }
                              }
                            },
                            [
                              _c("span", { attrs: { "aria-hidden": "true" } }, [
                                _vm._v("×")
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "modal-body" }, [
                          !_vm.secondaryCaregiverConsent
                            ? _c("div", [
                                _c("p", {
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.data.welcomepage.personaldataText
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c("p", {
                                  staticClass: "text-primary-fh",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.data.welcomepage.consentScreeningText
                                    )
                                  }
                                }),
                                _vm._v(" "),
                                _c("div", { staticClass: "clearfix" }),
                                _vm._v(" "),
                                _c(
                                  "button",
                                  {
                                    staticClass:
                                      "btn btn-primary btn-lg btn-block",
                                    class:
                                      _vm.secondaryCaregiverConsent === true
                                        ? "active"
                                        : "",
                                    on: {
                                      click: function($event) {
                                        return _vm.giveSecondaryCaregiverConsent()
                                      }
                                    }
                                  },
                                  [
                                    _vm._v(
                                      "\n              Ge samtycke\n            "
                                    )
                                  ]
                                )
                              ])
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.secondaryCaregiverChildren &&
                          _vm.secondaryCaregiverChildren.length > 0 &&
                          _vm.secondaryCaregiverConsent
                            ? _c("div", [
                                _c("div", { staticClass: "clearfix m-b-100" }),
                                _vm._v(" "),
                                !_vm.hasConsentToBeGiven
                                  ? _c(
                                      "h5",
                                      {
                                        staticClass: "text-primary-fh text-left"
                                      },
                                      [
                                        _vm._v(
                                          "\n              Du har gett samtycke åt samtliga barn ✓\n            "
                                        )
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasConsentToBeGiven
                                  ? _c(
                                      "h5",
                                      { staticClass: "text-danger text-left" },
                                      [
                                        _c("strong", [
                                          _vm._v(
                                            "Du behöver ge samtycke åt dina barn"
                                          )
                                        ])
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                !_vm.hasConsentToBeGiven
                                  ? _c("p", [
                                      _vm._v(
                                        "\n              I listan nedan ser du vilka samtyckesval du gjort.\n            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.hasConsentToBeGiven
                                  ? _c("p", [
                                      _vm._v(
                                        "\n              I listan nedan ser du vilka barn som är i behov av din uppmärksamhet.\n            "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "select",
                                  {
                                    staticClass: "form-control",
                                    on: {
                                      change: function($event) {
                                        return _vm.routeToConsentMinor($event)
                                      }
                                    }
                                  },
                                  [
                                    _c("option", { domProps: { value: 0 } }, [
                                      _vm._v("- Välj barn -")
                                    ]),
                                    _vm._v(" "),
                                    _vm._l(
                                      _vm.secondaryCaregiverChildren,
                                      function(child, i) {
                                        return _c(
                                          "option",
                                          {
                                            key: i,
                                            class: [
                                              _vm.getConsentStatus(child) ===
                                              "consent-to-give-finished"
                                                ? "text-success"
                                                : "",
                                              _vm.getConsentStatus(child) ===
                                              "consent-to-give-remains"
                                                ? "text-danger"
                                                : ""
                                            ],
                                            domProps: { value: child.personId }
                                          },
                                          [
                                            _vm._v(
                                              "\n                  " +
                                                _vm._s(
                                                  child.firstName +
                                                    " " +
                                                    child.lastName
                                                ) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      }
                                    )
                                  ],
                                  2
                                )
                              ])
                            : _vm._e()
                        ])
                      ])
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "modal fade wrapper-margin-top",
              attrs: {
                id: "registerModal",
                role: "dialog",
                "aria-labelledby": "registerModalLabel",
                "aria-hidden": "true"
              }
            },
            [
              _c(
                "div",
                { staticClass: "modal-dialog", attrs: { role: "document" } },
                [
                  _c("div", { staticClass: "modal-content" }, [
                    _c("div", { staticClass: "modal-header" }, [
                      !_vm.hasRegistered
                        ? _c(
                            "h5",
                            {
                              staticClass: "modal-title",
                              attrs: { id: "registerModalLabel" }
                            },
                            [
                              _vm._v(
                                "\n            Din registrering pågår\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.hasRegistered
                        ? _c(
                            "h5",
                            {
                              staticClass: "modal-title",
                              attrs: { id: "registerModalLabel" }
                            },
                            [
                              _vm._v(
                                "\n            Din registrering lyckades\n          "
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "close",
                          attrs: { type: "button", title: "Logga ut" },
                          on: {
                            click: function($event) {
                              return _vm.closeModal()
                            }
                          }
                        },
                        [
                          _c("span", { attrs: { "aria-hidden": "true" } }, [
                            _vm._v("×")
                          ])
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "modal-body" }, [
                      !_vm.hasRegistered
                        ? _c("div", { staticClass: "register-card" }, [
                            _c("div", { staticClass: "card-body" }, [
                              _vm._v(
                                "\n              Vänligen vänta medan registering sker..\n            "
                              )
                            ])
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix--min" }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "alert alert-danger alert-register" },
                        [
                          _c("strong", [
                            _vm._v("Ett fel uppstod, vi beklagar för detta.")
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "clearfix--min" }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary btn-sm",
                              on: {
                                click: function($event) {
                                  return _vm.closeModal()
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              Gå till startsidan\n            "
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _vm.hasRegistered
                        ? _c("div", { staticClass: "register-card" }, [
                            _vm._m(1)
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("div", { staticClass: "clearfix" }),
                      _vm._v(" "),
                      _c("div", { staticClass: "modal-footer" }, [
                        _vm.hasRegistered
                          ? _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: {
                                  type: "button",
                                  "data-dismiss": "modal"
                                }
                              },
                              [_vm._v("Stäng")]
                            )
                          : _vm._e()
                      ])
                    ])
                  ])
                ]
              )
            ]
          ),
          _vm._v(" "),
          _c("Alert"),
          _vm._v(" "),
          _c(
            "vue-cookie-accept-decline",
            {
              ref: "cookies",
              attrs: {
                elementId: "cookies",
                debug: false,
                position: "bottom-left",
                type: "floating",
                disableDecline: true,
                transitionName: "slideFromBottom",
                showPostponeButton: false
              }
            },
            [
              _c("div", { attrs: { slot: "message" }, slot: "message" }, [
                _vm._v("\n      Denna sida använder cookies. "),
                _c("br"),
                _vm._v("\n      Läs mer "),
                _c(
                  "a",
                  {
                    attrs: {
                      href: "https://www.pts.se/cookies",
                      target: "_blank"
                    }
                  },
                  [_vm._v("här")]
                ),
                _vm._v(".\n    ")
              ]),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { slot: "acceptContent" }, slot: "acceptContent" },
                [_vm._v("Jag förstår")]
              )
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "alert alert-research alert-success clearfix" },
      [_c("strong", [_vm._v("Din vårdnadshavare har nu blivit notifierad!")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card-body" }, [
      _vm._v(
        "\n              Du har nu tillgång att börja kaskadscreeningen. "
      ),
      _c("br"),
      _vm._v(
        "\n              Vänligen stäng detta fönster och fortsätt med samtycke.\n            "
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d4b7673c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4b7673c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Welcome.vue
// module id = null
// module chunks = 